<template>
  <div
    @click.left="submitFilter"
    :class="{isMove: type === CHART_STATUS_TYPE__EDIT}"
    class="ry-form__dashboard-filter-btn">
    <div
      class="loading-container"
      v-if="!current.isLoad">
      <van-loading
        type="spinner"
        size="20">
      </van-loading>
    </div>
    筛选
  </div>
</template>

<script>
  import {CHART_STATUS_TYPE__EDIT, CHART_TYPE__FILTER_CONTROL} from "../types"
  import {clone} from "../../../assets/js/Untis";

  export default {
    props: {
      value: Object,
      type: {
        type: Number,
        default: CHART_STATUS_TYPE__EDIT
      }
    },
    data() {
      return {
        current: this.value,
        CHART_STATUS_TYPE__EDIT
      }
    },
    methods: {
      submitFilter() {
        if (this.type !== CHART_STATUS_TYPE__EDIT && this.current.isLoad) {
          const dashboard = this.current.parent
          dashboard.children.forEach(chart => {
            if (chart.chartType === CHART_TYPE__FILTER_CONTROL) {
              chart.value.fixedValue = chart.chartPropertiesHolder.fixedValue
              chart.value.method = chart.chartPropertiesHolder.method
              chart.value.value = clone(chart.chartPropertiesHolder.value)
            }
          })
          this.current.isLoad = false
          if (dashboard) dashboard.submitFilter().then(() => {
            this.$toast.success('筛选完成')
            setTimeout(() => {
              this.current.isLoad = true
            }, 400)
          })
        }
      }
    }
  }
</script>

<style rel="stylesheet" lang="less">
  .ry-form__dashboard-filter-btn {
    width: 100%;
    height: 100%;
    background-color: #19be6b;
    color: #f5f5f5;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: pointer;
    user-select: none;

    .el-button {
      padding: 3px;
      position: absolute;
      right: -12px;
      top: -12px;
      z-index: 1;
      width: 20px;
      height: 20px;

      &:hover {
        border-color: #e6e6e6;
      }
    }

    &.isMove {
      cursor: move;
    }
  }
</style>
